
export interface IPaginationModelArgs {
    // the total number of available objects reported by the server
    total: number;
    // the current limit
    limit: number;
    // the current offset
    offset: number;
    // the number of objects currently in local store
    localObjectCount: number;
}

export class PaginationModel {
    _total: number;
    _limit: number;
    _offset: number;
    _localObjectCount: number;

    constructor(args: IPaginationModelArgs) {
        this._total = args.total;
        this._limit = args.limit;
        this._offset = args.offset;
        this._localObjectCount = args.localObjectCount;
    }

    get limit(): number {
        return this._limit;
    }

    get total(): number {
        return this._total;
    }

    get offset(): number {
        return this._offset;
    }

    get localObjectCount(): number {
        return this._localObjectCount;
    }

    get canLoadMore(): boolean {
        return this.localObjectCount < this.total;
    }
}



// WEBPACK FOOTER //
// ./src/core/models/pagination.model.ts